module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "darkest",
    domProps: {
      "innerHTML": _vm._s(_vm.notification.message)
    }
  }), _vm._v(" "), (_vm.showInvoiceBtn) ? _c('button', {
    staticClass: "btn tertiary narrow mt-2",
    on: {
      "click": _vm.viewBooking
    }
  }, [_vm._v("View booking")]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a28ea80e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a28ea80e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/notifications/bodySimple.vue
// module id = 2430
// module chunks = 0